((win) => {
  const templateStyle = `
    <style>
        .popup {
            min-width: 40%; !important;
        }
        /*
         當螢幕寬度 為 600px 以上 則套用以下樣式
         */
        @media (min-width: 600px) {
            .popup {
                max-width: 40%; !important;
                /*  垂直置中  */
                position: fixed;
                top: 18%;
                left: 36%;
            }
        }

        .popup p  {
            margin-left: 10px; !important;
            margin-right: 10px; !important;
        }
    </style>
  `
  const createTemplate = () => {
    return `
    <link rel="stylesheet" href="../../../css/reset.css">
    <link rel="stylesheet" href="../../../css/header.css">
    <link rel="stylesheet" href="../../../css/all.css">
    ${templateStyle}
    <div class="popup">
        <div class="content">
          <h1>尚未登入</h1>
          <p>登入後才能開啟，是否立即登入?</p>
          <p></p>
          <div class="btn">
            <a href="#" ><span id="loginConfirmBtn">確定</span></a>
            <a href="#"><span id="loginCancel">取消</span></a>
          </div>
        </div>
    </div>
    `
  }

  customElements.define('un-login-pop', class extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
      this.shadowRoot.innerHTML = createTemplate()
      this.addEventListeners()
    }

    addEventListeners() {
      // loginConfirmBtn
      const confirmBtn = this.shadowRoot.getElementById("loginConfirmBtn")
      const cancelBtn = this.shadowRoot.getElementById("loginCancel")
      if (confirmBtn) {
        confirmBtn.addEventListener('click', () => {
          cancelBtn.click();
          win.login();
        })
      }
    }

  })
})(window)
